import * as React from "react";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { PPToProductAction } from "./Actions/PPToProductActions";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { Review } from "./Components/Review/Review";
import { InvestmentDetails } from "./Components/InvestmentDetails/investmentDetails";
import { PPToProductSteppersMap, productMap } from "./Resource/Contents";
import { PPToProductInstructionStore } from "./Store/Variable";
import { IStepConfig, StepType } from "../../../../Shared/Process/Process/Process";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { Action } from "../../../Actions/Action";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { ProcessType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { SubAccount } from "../../../../../Wrap/Models/Domains/Account/SlAccounts/SubAccount";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { AccountRoleStore, ClientAccountStore, TreasuredAssetsStore } from "../../../Stroes/Variable";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { DocumentsAndDeclarations } from "../Common/Documents/Components/DocumentsAndDeclarations";
import { processTypeEnum } from "../Common/Resource/Contents";
import { isJointOrTrustAccount } from "../NewBusinessWizard/Components/WrapperSelection/WrapperSelctionHelper";

interface IPPtoAbrdnSIPPWizardState extends IAccountContextWizardComponentState {
    extraInfo: any;
    showErrorMsgPopUp?: (msg: string[], showNow?: boolean) => void;
}
export class PPtoAbrdnSIPPWizard extends AccountContextWizardComponent<IPPtoAbrdnSIPPWizardState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(PPToProductInstructionStore, () => this.onInstructionStoreChange());
    }

    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: {
                hasCashIsa: false,
                treasuredAssetProductIds: null,
                treasuredAssetsInstructionId: null,
            },
        };
    }
    private onInstructionStoreChange() {
        if (PPToProductInstructionStore.getActionType() == ActionType.Success) {
            const data = PPToProductInstructionStore.getData();
            this.setState({
                isLoading: false,
                data: data,
                active: data?.Status === InstructionStatus.Pending || data?.Status === InstructionStatus.NotSpecified,
            });
        }
    }

    onAssetChange(asset) {
        const tmpData = this.state.data;
        tmpData.Contribution.BedAndProductWrapperInstruction.SellAllocations = asset;
        this.setState({ data: tmpData });
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        this.getProductDetails(hierarchyId);
        if (!this.state.data) {
            const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
            const id = getQueryParameters()["id"];
            const type = Number(getQueryParameters()["type"]);
            PPToProductAction.getInstruction(
                id,
                type,
                hierarchyId,
                subAccountHierarchyId,
                getQueryParameters()["customer"],
                ProcessType.BedAndAbrdnProduct,
                ProcessType.BedAndAbrdnProduct.toString()
            );
        }
    }

    componentDidUpdate(prevProps) {}

    private getProductDetails(hierarchyId: string) {
        const _date = JsonDateParser.getFormatDateString(new Date(), "yyyy/MM/dd") as any;
        Action.getProductsValuationDetailSummary(hierarchyId, null, _date);
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);
        const { data, customer } = this.state;
        const steppers: IStepConfig[] = [
            {
                title: PPToProductSteppersMap.investmentDetails,
                url: Urls.get().PPToAbrdnSIPPInvestmentDetails,
                path: Contents.URLMap.investmentDetails,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },
                component: <InvestmentDetails 
                onAssetChange={(asset) => this.onAssetChange(asset)} 
                {...this.getStepProps(0)} clientAccount={this.state.clientAccount} ToAbrdnSIPP = {true} />,
            },
            {
                title: PPToProductSteppersMap.review,
                url: Urls.get().PPToAbrdnSIPPReview,
                path: Contents.URLMap.review,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },
                needPrint: true,
                component: <Review {...this.getStepProps(1)} type={type} clientAccount={this.state.clientAccount} />,
            },
            {
                title: PPToProductSteppersMap.documentsAndDeclarations,
                url: Urls.get().PPToAbrdnSIPPDocumentsAndDeclarations,
                path: Contents.URLMap.documentAndDeclarations,
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[2].isValid(),
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <DocumentsAndDeclarations
                        {...this.getStepProps(2)}
                        processType={processTypeEnum.PPToSIPP}
                        clAccountId={this.state.clientAccount?.HeadClAccountId}
                        isJointOrTrust={isJointOrTrustAccount(this.state.clientAccount?.InvestorType)}
                        subAccountType={type}
                        customerId={customer.CustomerId}
                    />
                ),
            },
            {
                title: PPToProductSteppersMap.confirm,
                url: Urls.get().PPToAbrdnSIPPConfiramation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={`We've sucessfully received your instruction for  ${
                            data?.ClientDetails?.FirstName
                        } ${data?.ClientDetails?.LastName} (${
                            this.state?.clientAccount?.SubAccounts?.find(
                                (x) =>
                                    x.HierarchyId ==
                                        data.Contribution.BedAndProductWrapperInstruction.FromHierarchyId
                                            ?.HierarchyIdString ?? ""
                            )?.ClAccountId
                        }).`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
        this.stepperConfig = steppers;
    }

    setProcessProps() {
        // const type = Number(getQueryParameters()["type"]);
        const { data } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "PP to Aberdeen SIPP";
        // processProps.needSplitHeader = {
        //     fromStep: 0,
        //     splitHeaderMain: `${data?.ClientDetails?.PersonalDetails?.GivenName} ${data?.ClientDetails?.PersonalDetails?.SecondFamilyName}`,
        //     splitHeaderSub: this.state.clientAccount?.HeadClAccountId,
        // };
        processProps.subTitle = "PERSONAL PORTFOLIO";
        return processProps;
    }

    // saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {
    //     if (!params["id"]) params["id"] = this.state.data?.DrawdownIncomeAmendmentInstruction?.Id;
    //     PPToProductAction.saveInstruction(this.state.data, (result) => {
    //         this.setState({ onPosting: false });
    //         if (result.length > 0) {
    //             this.setState({ errorMsg: result, isShowErrorMsg: true });
    //         } else {
    //             if (to == -1) {
    //                 this.onExit();
    //             } else {
    //                 Navigator.navigateTo(toUrl, {
    //                     queryParamsObject: params,
    //                     scrollAfterNavigating: true,
    //                 });
    //             }
    //         }
    //     });
    // }

    saveInstruction(from, to, toUrl, params) {
        if (!params["id"]) {
            params["id"] = this.state.data.HierarchyId;
            PPToProductAction.postInstructionProcess(
                HierarchyIdHelper.generateHierarchyId(this.state.data.HierarchyId).entityId,
                ProcessType.BedAndAbrdnProduct
            );
        }
        const { customer } = this.state;

        PPToProductAction.saveInstruction(from, this.state.data, (result) => {
            this.setState({ onPosting: false });
            if (result?.length > 0) {
                this.setState({
                    errorMsg: result.map((x) => x.UserMessage),
                    isShowErrorMsg: true,
                });
            } else {
                if (this.state.extraInfo.treasuredAssetsInstructionId) {
                    Action.setInstructionTreasuredAssetsProductIds(
                        this.state.extraInfo.treasuredAssetsInstructionId,
                        this.state.extraInfo.treasuredAssetProductIds,
                        () => {
                            this.setState({ onPosting: false });
                            this.navigate(to, toUrl, params);
                        }
                    );
                } else {
                    this.setState({ onPosting: false });
                    this.navigate(to, toUrl, params);
                }
            }
        });
    }

    private navigate(to, toUrl, params) {
        if (to == -1) {
            this.onExit();
        } else {
            Navigator.navigateTo(toUrl, {
                queryParamsObject: params,
                scrollAfterNavigating: false,
            });
        }
    }

    onCancel() {
        this.onExit();
    }
    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }
    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        PPToProductAction.submitInstruction(
            this.state.data.HierarchyId,
            this.state.data.Contribution,
            this.state.data.ClientDetails.ActorId,
            this.state.data.SubAccountClientDetail.ClAccountId,
            () => this.setState({ isSubmitting: false })
        );
    }
}
